export class ReportEmployee {
  constructor(
    readonly id?: string,
    readonly name?: string,
    readonly icNumber?: string,
    readonly contactNumber?: string,
    readonly temperature?: string,
    readonly timestamp?: Date
  ) {}
}

export const ReportEmployeeConverter: firebase.firestore.FirestoreDataConverter<ReportEmployee> = {
  toFirestore(report: ReportEmployee): firebase.firestore.DocumentData {
    return {
      id: report.id,
      name: report.name,
      icNumber: report.icNumber,
      contactNumber: report.contactNumber,
      temperature: report.temperature,
      timestamp: report.timestamp,
    };
  },
  fromFirestore(
    snapshot: firebase.firestore.QueryDocumentSnapshot,
    options: firebase.firestore.SnapshotOptions
  ): ReportEmployee {
    const data = snapshot.data(options)!;

    return new ReportEmployee(
      snapshot.id,
      data.name,
      data.icNumber,
      data.contactNumber,
      data.temperature,
      data.timestamp?.toDate()
    );
  },
};
